/**
 * Utility functions for date formatting based on locale
 */

/**
 * Get locale-specific date format patterns based on language
 * @param {string} language - The current language code
 * @returns {object} Object containing format patterns for the language
 */
export const getLocaleFormats = (language) => {
  const formats = {
    en: {
      monthDay: 'MMM D',
      monthDayFull: 'MMMM D',
      month: 'MMM',
      longDate: 'll',
    },
    fr: {
      monthDay: 'D MMM',
      monthDayFull: 'D MMMM',
      month: 'MMM',
      longDate: 'll',
    },
    de: {
      monthDay: 'D. MMM',
      monthDayFull: 'D. MMMM',
      month: 'MMM',
      longDate: 'll',
    },
    es: {
      monthDay: 'D MMM',
      monthDayFull: 'D MMMM',
      month: 'MMM',
      longDate: 'll',
    },
  }

  // Default to English if language not found
  return formats[language] || formats.en
}

/**
 * Capitalize the first letter of a string
 * Useful for French month names that need capitalization at the beginning of date ranges
 * @param {string} str - The string to capitalize
 * @returns {string} The string with the first letter capitalized
 */
export const capitalizeFirstLetter = (str) => {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1)
}
